import {defineStore} from "pinia";
import {ref} from "vue";

export const useStopsStore = defineStore('stops', () => {
    const currentStopIndex = ref(0)
    const stops = ref([])
    const currentStopInfo = ref(null)
    const selectedMarker = ref(null)
    const mainGoogleMapRef = ref(null)

    return {
        currentStopIndex,
        currentStopInfo,
        mainGoogleMapRef,
        stops,
        selectedMarker,
    }
})
